// extracted by mini-css-extract-plugin
export default {"page-header":"page-header_gHr75"};